import { render, staticRenderFns } from "./ClientCell.vue?vue&type=template&id=726a7608&scoped=true&"
import script from "./ClientCell.vue?vue&type=script&lang=js&"
export * from "./ClientCell.vue?vue&type=script&lang=js&"
import style0 from "./ClientCell.vue?vue&type=style&index=0&id=726a7608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726a7608",
  null
  
)

export default component.exports